import { DF_COLLAPSE_EXPAND } from '@lib/fresco';
import { Component, Input, OnInit } from '@angular/core';
import { generateGuid } from '@app/shared/utils/uuid';

/**
 * Expand collapse wrapper box element in a border or shadow border
 * Included " | ^ "
 * @example
 * ```
 * <dgx-content-expander [hasShadow]="true">
 *  <div header>header content</div>
 *  <div body> body content</div>
 * </dgx-content-expander>
 */
@Component({
  selector: 'dgx-content-expander',
  templateUrl: './content-expander.component.html',
  styleUrls: ['./content-expander.component.scss'],
  animations: [DF_COLLAPSE_EXPAND],
})
export class ContentExpanderComponent implements OnInit {
  @Input() public hasShadow: boolean = false;
  public uid: string;
  public isOpen: boolean = false;

  constructor() {}

  public ngOnInit(): void {
    this.uid = generateGuid();
  }

  /**
   * Toggle the details section
   *
   * @param id - the id of the experience.
   */
  public toggleDetails(): void {
    this.isOpen = !this.isOpen;
  }
}
